import { render, staticRenderFns } from "./laser-form.vue?vue&type=template&id=50fd8d54&scoped=true&"
import script from "./laser-form.vue?vue&type=script&lang=js&"
export * from "./laser-form.vue?vue&type=script&lang=js&"
import style0 from "./laser-form.vue?vue&type=style&index=0&id=50fd8d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fd8d54",
  null
  
)

export default component.exports